<app-msg [showMsg]="showMsg" [tipoMsg]="tipoMsg" [tituloMsg]="tituloMsg" [detalleMsg]="detalleMsg"></app-msg>
